import goldBars from '../assets/gold_bars.png';
import Copy from './Copy';
import Cta, { ctaProps } from './Cta';

/* "Buy Gold and get 5% back" — gold bars (with a blurred halo copy behind them)
   poke out above the card. `data` is the API `gold` section. */
export default function GoldSection({ data, onAction }) {
  return (
    <section className="bbd-gold">
      <div className="bbd-gold-art">
        <div className="bbd-gold-shadow" />
        <div className="bbd-gold-img bbd-gold-blur" aria-hidden>
          <img src={goldBars} alt="" />
        </div>
        <div className="bbd-gold-img">
          <img src={goldBars} alt="" />
        </div>
      </div>

      <p className="bbd-copy"><Copy text={data.text} highlight={data.highlight} /></p>

      <Cta {...ctaProps(data.cta, onAction)} />
    </section>
  );
}
